'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { isSessionValid } from '@lichtblick/auth';
import { SESSION_CHECK_INTERVAL_MS, savePendingLogoutRedirectUrl } from '@lichtblick/utils';

export type SessionWatcherSession = {
  access_token: string;
  error?: 'RefreshTokenError';
  errorDetails?: unknown;
  expires: string;
  user?: {
    email?: string | null;
    image?: string | null;
    name?: string | null;
  };
} | null;

export const SessionWatcher = ({ session }: { session: SessionWatcherSession }): null => {
  const pathname = usePathname();

  useEffect(() => {
    const checkSession = async () => {
      try {
        if (session && !isSessionValid(session)) {
          const currentPath =
            typeof window !== 'undefined'
              ? `${pathname || window.location.pathname}${window.location.search}${window.location.hash}`
              : pathname;

          if (typeof window !== 'undefined' && currentPath) {
            savePendingLogoutRedirectUrl(currentPath);
          }

          await fetch(`/api/auth/signout?callbackUrl=${encodeURIComponent(currentPath ?? pathname ?? '/')}`, {
            method: 'POST',
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Session validation failed:', error);
      }
    };

    checkSession();

    const interval = setInterval(checkSession, SESSION_CHECK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [pathname, session]);

  return null;
};
